export default {
    type: 'locations',
    name: 'Locations',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleLocations',
            loader: () => import('./ModuleLocations')
        }
    }
};
